/* const dbJson = JSON.parse(`[
    {
        "ID": 10548,
        "StoreNumber": "4 Power Quartz",
        "StreetAddress": "2440 Dinneen Avenue",
        "City": "Orlando",
        "State": "FL",
        "Zip": "32804",
        "PhoneNumber": "(407) 739-3153",
        "Longitude": "-81.41154479980468688",
        "Latitude": "28.57599449157714848",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10549,
        "StoreNumber": "A & E Kitchen and Bath",
        "StreetAddress": "189 Route 9 South",
        "City": "Manalapan",
        "State": "NJ",
        "Zip": "07726",
        "PhoneNumber": "(732) 677-3977",
        "Longitude": "-74.3028204",
        "Latitude": "40.2982754",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10550,
        "StoreNumber": "A to Z Kitchens and Remodeling",
        "StreetAddress": "4500 N. Hiatus Rd.",
        "City": "Sunrise",
        "State": "FL",
        "Zip": "33351",
        "PhoneNumber": "(786) 286-3876",
        "Longitude": "-80.2972828",
        "Latitude": "26.1313397",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10551,
        "StoreNumber": "A&L Building Materials",
        "StreetAddress": "1100 George Wallace Hwy",
        "City": "Russellville",
        "State": "AL",
        "Zip": "35654",
        "PhoneNumber": "(256) 332-8181",
        "Longitude": "-87.6774225",
        "Latitude": "34.584893",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10552,
        "StoreNumber": "AEI Interiors, LLC",
        "StreetAddress": "105 Pleasant Drive",
        "City": "Aliquippa",
        "State": "PA",
        "Zip": "15001",
        "PhoneNumber": "(724) 378-1925",
        "Longitude": "-80.3151592",
        "Latitude": "40.6330103",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10553,
        "StoreNumber": "AG Stone",
        "StreetAddress": "325 Mealy Dr.",
        "City": "Atlantic Beach",
        "State": "FL",
        "Zip": "32233",
        "PhoneNumber": "(904) 477-1478",
        "Longitude": "-81.4186318",
        "Latitude": "30.3389649",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10554,
        "StoreNumber": "Aggressive Consulting, Inc.",
        "StreetAddress": "4573 Exchange Ave.",
        "City": "Naples",
        "State": "FL",
        "Zip": "34104",
        "PhoneNumber": "(239) 370-2403",
        "Longitude": "-81.7539029",
        "Latitude": "26.1592704",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10555,
        "StoreNumber": "American Groundskeeping",
        "StreetAddress": "607 Turnberry Lane",
        "City": "Oakdale",
        "State": "PA",
        "Zip": "15071",
        "PhoneNumber": "(724) 307-3070",
        "Longitude": "-80.176848",
        "Latitude": "40.3822255",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10556,
        "StoreNumber": "Arch and Gable",
        "StreetAddress": "424 Indiana st",
        "City": "Lawrence",
        "State": "KS",
        "Zip": "66044",
        "PhoneNumber": "(785) 418-2311",
        "Longitude": "-95.242584",
        "Latitude": "38.9759002",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10557,
        "StoreNumber": "Arnold Roberts Signature Homes",
        "StreetAddress": "4325 Chiquita Blvd S.",
        "City": "Cape Coral",
        "State": "FL",
        "Zip": "33904",
        "PhoneNumber": "(239) 288-9185",
        "Longitude": "-82.0065816",
        "Latitude": "26.5711841",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10558,
        "StoreNumber": "Atlantic Cabinetry",
        "StreetAddress": "363 Tequesta Drive",
        "City": "Jupiter",
        "State": "FL",
        "Zip": "33469",
        "PhoneNumber": "(561) 575-0060",
        "Longitude": "-80.0939323",
        "Latitude": "26.9595564",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10559,
        "StoreNumber": "BarrWood Cabinets",
        "StreetAddress": "135 Eaton Store Rd.",
        "City": "Jasper",
        "State": "GA",
        "Zip": "30143",
        "PhoneNumber": "(770) 771-3354",
        "Longitude": "-84.4035134",
        "Latitude": "34.3908465",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10560,
        "StoreNumber": "Beattie Development",
        "StreetAddress": "857 SW 47th Street",
        "City": "Cape Coral",
        "State": "FL",
        "Zip": "33904",
        "PhoneNumber": "239-851-5203",
        "Longitude": "-81.992672",
        "Latitude": "26.564765",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10561,
        "StoreNumber": "ecker Home Maintenance",
        "StreetAddress": "5880 Shirley Street",
        "City": "Naples",
        "State": "FL",
        "Zip": "34109",
        "PhoneNumber": "(239) 351-6820",
        "Longitude": "-81.7810077",
        "Latitude": "26.2175172",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10562,
        "StoreNumber": "Bison Countertops",
        "StreetAddress": "1929 Hwy 12S",
        "City": "Ashland City",
        "State": "TN",
        "Zip": "37015",
        "PhoneNumber": "(615) 792-8812",
        "Longitude": "-87.0151688",
        "Latitude": "36.231038",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10563,
        "StoreNumber": "lue Spruce",
        "StreetAddress": "126 Depot St",
        "City": "Franklin",
        "State": "NC",
        "Zip": "28734",
        "PhoneNumber": "(828) 369-9599",
        "Longitude": "-83.37399",
        "Latitude": "35.177499",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10564,
        "StoreNumber": "lue Water Kitchens & More",
        "StreetAddress": "6165 Lakeshore Road",
        "City": "Lakeport",
        "State": "MI",
        "Zip": "48059",
        "PhoneNumber": "(810) 385-8791",
        "Longitude": "-82.4784212",
        "Latitude": "43.0875416",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10565,
        "StoreNumber": "uddy Allen Carpet One Floor & Home",
        "StreetAddress": "2405 Lebanon Pike",
        "City": "Nashville",
        "State": "TN",
        "Zip": "37214",
        "PhoneNumber": "(615) 883-3289",
        "Longitude": "-86.681607",
        "Latitude": "36.1685659",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10566,
        "StoreNumber": "uilders Supply of Delmarva",
        "StreetAddress": "36503 South Street",
        "City": "Rehoboth Beach",
        "State": "DE",
        "Zip": "19971",
        "PhoneNumber": "(302) 745-1114",
        "Longitude": "-75.127218",
        "Latitude": "38.726403",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10567,
        "StoreNumber": "uilt By Waters",
        "StreetAddress": "4447 Emerald Palms Ln",
        "City": "Winter Haven",
        "State": "FL",
        "Zip": "33884",
        "PhoneNumber": "(863) 289-2690",
        "Longitude": "-81.6709751",
        "Latitude": "27.968643",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10568,
        "StoreNumber": ".C.E. Long Construction",
        "StreetAddress": "653 Smith Creek Road",
        "City": "New Market",
        "State": "VA",
        "Zip": "228444",
        "PhoneNumber": "(540) 481-3918",
        "Longitude": "-78.6641943",
        "Latitude": "38.6265529",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10569,
        "StoreNumber": "abinet King Inc.",
        "StreetAddress": "25594 Canal Rd.",
        "City": "Orange Beach",
        "State": "AL",
        "Zip": "36561",
        "PhoneNumber": "(251) 233-5178",
        "Longitude": "-87.5882503",
        "Latitude": "30.2899489",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10570,
        "StoreNumber": "abinet King LLC",
        "StreetAddress": "620 Sandy Lane Suite E",
        "City": "Surfside Beach",
        "State": "SC",
        "Zip": "29575",
        "PhoneNumber": "(843) 286-9227",
        "Longitude": "-78.9861466",
        "Latitude": "333.6098146",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10571,
        "StoreNumber": "Cabinet Sales Of North Florida",
        "StreetAddress": "7230 SW 201 Avenue",
        "City": "Dunnellon",
        "State": "FL",
        "Zip": "34431",
        "PhoneNumber": "(352) 427-2647",
        "Longitude": "-82.4550753",
        "Latitude": "29.1145979",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10572,
        "StoreNumber": "abinetree Kitchen & Bath Design, LLC",
        "StreetAddress": "1955 S Tamiami Trail",
        "City": "Venice",
        "State": "FL",
        "Zip": "34293",
        "PhoneNumber": "(941) 488-6474",
        "Longitude": "-82.4145596",
        "Latitude": "27.0601618",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10573,
        "StoreNumber": "abinetry Pros",
        "StreetAddress": "101 Crossings West Drive  Suite 100",
        "City": "Lake Ozark",
        "State": "MO",
        "Zip": "65049",
        "PhoneNumber": "(573) 286-5284",
        "Longitude": "-92.6409753",
        "Latitude": "38.187713",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10575,
        "StoreNumber": "ameron Kitchen and Bath Designs",
        "StreetAddress": "8019 Palm Street",
        "City": "New Orleans",
        "State": "LA",
        "Zip": "70125",
        "PhoneNumber": "(504) 486-3759",
        "Longitude": "-90.1105621",
        "Latitude": "29.9639829",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10576,
        "StoreNumber": "AP Carpet Inc.",
        "StreetAddress": "535 S. Emerson Street",
        "City": "Wichita",
        "State": "KS",
        "Zip": "67209",
        "PhoneNumber": "(316) 262-3400",
        "Longitude": "-97.4306757",
        "Latitude": "37.6753097",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10577,
        "StoreNumber": "CA Global",
        "StreetAddress": "4301 Earth City Expressway",
        "City": "Earth City",
        "State": "MO",
        "Zip": "63045",
        "PhoneNumber": "(314) 323-3416",
        "Longitude": "-90.4625428",
        "Latitude": "38.7727631",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10578,
        "StoreNumber": "ENTRAL SUPPLY COMPANY",
        "StreetAddress": "701 EAST WALLACE STREET",
        "City": "Fort Wayne",
        "State": "IN",
        "Zip": "46803",
        "PhoneNumber": "(260) 745-4961",
        "Longitude": "-85.1280154",
        "Latitude": "41.070369",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10579,
        "StoreNumber": "harlotte Harbor Construction Inc.",
        "StreetAddress": "512 E Marion",
        "City": "Punta Gorda",
        "State": "FL",
        "Zip": "33950",
        "PhoneNumber": "(941) 347-4665",
        "Longitude": "-82.0443333",
        "Latitude": "26.9395595",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10580,
        "StoreNumber": "KF",
        "StreetAddress": "10325 J Street",
        "City": "Omaha",
        "State": "NE",
        "Zip": "68127",
        "PhoneNumber": "531-329-3235",
        "Longitude": "-96.0736417",
        "Latitude": "41.2136352",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10581,
        "StoreNumber": "lassic Cabinetry",
        "StreetAddress": "2601 Broad Street  Suite 1A",
        "City": "Chattanooga",
        "State": "TN",
        "Zip": "37408",
        "PhoneNumber": "(423) 266-0077",
        "Longitude": "-85.3170135",
        "Latitude": "35.0275396",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10582,
        "StoreNumber": "oastal Cabinet Works, Inc.",
        "StreetAddress": "303 Sunnyside Blvd Suite",
        "City": "Plainview",
        "State": "NY",
        "Zip": "11803",
        "PhoneNumber": "(516) 513-1555",
        "Longitude": "-73.4665431",
        "Latitude": "40.7976304",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10583,
        "StoreNumber": "onstruction Material Outlet, CMO",
        "StreetAddress": "17081 S. Tamiami Trail",
        "City": "Fort Myers",
        "State": "FL",
        "Zip": "33908",
        "PhoneNumber": "(239) 900-6795",
        "Longitude": "-81.8449346",
        "Latitude": "26.4919735",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10584,
        "StoreNumber": "ountertop & Cabinet Concierge, LLC",
        "StreetAddress": "485 N. Hwy 17-92 Suite 415",
        "City": "Longwood",
        "State": "FL",
        "Zip": "32750",
        "PhoneNumber": "(407) 687-0035",
        "Longitude": "-81.3261184",
        "Latitude": "28.703904",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10585,
        "StoreNumber": "rash Crew Construction",
        "StreetAddress": "1732 Indiana St",
        "City": "Orlando",
        "State": "FL",
        "Zip": "32805",
        "PhoneNumber": "(407) 492-8465",
        "Longitude": "-81.4043359",
        "Latitude": "28.5255199",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10586,
        "StoreNumber": "reative Masonry & Chimney LLC",
        "StreetAddress": "9065 Santa Lucia Dr.",
        "City": "Port Charlotte",
        "State": "FL",
        "Zip": "33981",
        "PhoneNumber": "(941) 216-1411",
        "Longitude": "-82.2225242",
        "Latitude": "26.9001407",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10587,
        "StoreNumber": "ustom Storage Solutions",
        "StreetAddress": "1726 Commerce",
        "City": "Holland",
        "State": "OH",
        "Zip": "43528",
        "PhoneNumber": "419) 517-3335",
        "Longitude": "-83.711604",
        "Latitude": "41.621718",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10588,
        "StoreNumber": "irect Stone Depot Inc.",
        "StreetAddress": "3140 SW 7th St",
        "City": "Ocala",
        "State": "FL",
        "Zip": "34474",
        "PhoneNumber": "(352) 622-8828",
        "Longitude": "-82.175256",
        "Latitude": "29.1795805",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10589,
        "StoreNumber": "ock and Deck Supply",
        "StreetAddress": "7300 Roscoe Road",
        "City": "Gulf Shores",
        "State": "AL",
        "Zip": "36542",
        "PhoneNumber": "(251) 525-0422",
        "Longitude": "-87.6488675",
        "Latitude": "30.3306686",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10590,
        "StoreNumber": "on B Construction",
        "StreetAddress": "115 N 1ST AVE",
        "City": "Bartow",
        "State": "FL",
        "Zip": "33830",
        "PhoneNumber": "(863) 585-4891",
        "Longitude": "-81.835125",
        "Latitude": "27.8966536",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10591,
        "StoreNumber": "owns Kitchens & More, LLC",
        "StreetAddress": "321 Lawtonwood Lane",
        "City": "Roebuck",
        "State": "SC",
        "Zip": "29376",
        "PhoneNumber": "(864) 729-0998",
        "Longitude": "-81.9486014",
        "Latitude": "34.8440143",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10592,
        "StoreNumber": "Q Dream Homes",
        "StreetAddress": "8730 N Pavilion Dr.",
        "City": "West Chester",
        "State": "OH",
        "Zip": "45069",
        "PhoneNumber": "(513) 874-2100",
        "Longitude": "-84.4594157",
        "Latitude": "39.3396476",
        "URI": "",
        "IsCLStore": "0",
        "Classification": "NULL"
    },
    {
        "ID": 10593,
        "StoreNumber": "Drifthouse Design LLC",
        "StreetAddress": "727 SERENOA RD",
        "City": "SANTA ROSA BEACH",
        "State": "FL",
        "Zip": "32459",
        "PhoneNumber": "(850) 460-0754",
        "Longitude": "-86.0674925",
        "Latitude": "30.3493428",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10594,
        "StoreNumber": "e.c. Barton",
        "StreetAddress": "3023 Browns lane",
        "City": "Jonesboro",
        "State": "FL",
        "Zip": "72401",
        "PhoneNumber": "(870) 932-6675",
        "Longitude": "-90.6882767",
        "Latitude": "35.8079667",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10595,
        "StoreNumber": "Eastside Kitchen and Bath",
        "StreetAddress": "995 N Goldenrod Road",
        "City": "Orlando",
        "State": "FL",
        "Zip": "32807",
        "PhoneNumber": "(407) 907-2627",
        "Longitude": "-81.2853905",
        "Latitude": "28.5565744",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10596,
        "StoreNumber": "Eureka Showroom & Design",
        "StreetAddress": "9310 Ulmerton Road",
        "City": "Largo",
        "State": "FL",
        "Zip": "33771",
        "PhoneNumber": "(727) 238-8143",
        "Longitude": "-82.767883",
        "Latitude": "27.8934773",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10597,
        "StoreNumber": "FJC Construction LLC",
        "StreetAddress": "3906 North Forbes Road",
        "City": "Plant City",
        "State": "FL",
        "Zip": "33565",
        "PhoneNumber": "(813) 967-3607",
        "Longitude": "-82.1868483",
        "Latitude": "28.0563572",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10598,
        "StoreNumber": "Flip Flop Cabinet and Tile Creations",
        "StreetAddress": "2840 Allen Hill Avenue",
        "City": "Melbourne",
        "State": "FL",
        "Zip": "32940",
        "PhoneNumber": "(321) 265-1450",
        "Longitude": "-80.6693922",
        "Latitude": "28.2138905",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10599,
        "StoreNumber": "GAR Cabinetry + Design",
        "StreetAddress": "361 5th Street North",
        "City": "St. Petersburg",
        "State": "FL",
        "Zip": "33710",
        "PhoneNumber": "(941) 243-7939",
        "Longitude": "-82.7106385",
        "Latitude": "27.7752552",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10600,
        "StoreNumber": "Gotcha Covered",
        "StreetAddress": "8480 Amber Hill Court",
        "City": "Lincoln",
        "State": "NE",
        "Zip": "68526",
        "PhoneNumber": "(402) 420-5566",
        "Longitude": "-96.6036085",
        "Latitude": "40.7334269",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10601,
        "StoreNumber": "Green Moon Media",
        "StreetAddress": "29606 Picana Lane",
        "City": "Wesley Chapel",
        "State": "FL",
        "Zip": "33543",
        "PhoneNumber": "(704) 718-4242",
        "Longitude": "-82.3483676",
        "Latitude": "28.2205379",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10602,
        "StoreNumber": "Grill Masters of Charleston",
        "StreetAddress": "874 Orleans Rd",
        "City": "Charleston",
        "State": "SC",
        "Zip": "29407",
        "PhoneNumber": "(843) 926-0046",
        "Longitude": "-80.0275201",
        "Latitude": "32.7966177",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10603,
        "StoreNumber": "Groen Landscape",
        "StreetAddress": "1904 Hart St",
        "City": "Dyer",
        "State": "IN",
        "Zip": "46311",
        "PhoneNumber": "(219) 895-0542",
        "Longitude": "-87.521966",
        "Latitude": "41.4972389",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10604,
        "StoreNumber": "Hartson Kitchen & Bath",
        "StreetAddress": "PO Box 434",
        "City": "Weirsdale",
        "State": "FL",
        "Zip": "32195",
        "PhoneNumber": "(352) 434-1441",
        "Longitude": "-81.9244429",
        "Latitude": "28.9818793",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10605,
        "StoreNumber": "Heritage Bay Cabinetry",
        "StreetAddress": "11780 METRO PKWY S",
        "City": "FORT MYERS",
        "State": "FL",
        "Zip": "33966",
        "PhoneNumber": "(239) 415-3909",
        "Longitude": "-81.8537046",
        "Latitude": "26.5720963",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10606,
        "StoreNumber": "Hines Supply",
        "StreetAddress": "1050 Corporate Grove Dr",
        "City": "Buffalo Grove",
        "State": "IL",
        "Zip": "60089",
        "PhoneNumber": "(847) 353-7700",
        "Longitude": "-87.9358315",
        "Latitude": "42.1747693",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10607,
        "StoreNumber": "Hippich Services Inc",
        "StreetAddress": "4735 Lena Rd",
        "City": "Bradenton",
        "State": "FL",
        "Zip": "34211",
        "PhoneNumber": "(941) 299-2032",
        "Longitude": "-82.455073",
        "Latitude": "27.4556442",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10608,
        "StoreNumber": "Home360 Concierge inc.",
        "StreetAddress": "3117 Edgewater Dr Ste 3474",
        "City": "Orlando",
        "State": "FL",
        "Zip": "34774",
        "PhoneNumber": "239-371-3487",
        "Longitude": "-81.3893387",
        "Latitude": "28.5799216",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10609,
        "StoreNumber": "ICS Cabinets",
        "StreetAddress": "14131 Ne Hwy 27 At",
        "City": "Williston",
        "State": "FL",
        "Zip": "32696",
        "PhoneNumber": "352-529-0168",
        "Longitude": "-82.4768189",
        "Latitude": "29.4604366",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10610,
        "StoreNumber": "Imagination Group LLC",
        "StreetAddress": "3779 Silver Star Road",
        "City": "Orlando",
        "State": "FL",
        "Zip": "32808",
        "PhoneNumber": "(407) 920-7889",
        "Longitude": "-81.4282832",
        "Latitude": "28.5784848",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10611,
        "StoreNumber": "J McDemott Home Services L",
        "StreetAddress": "3822 Countyside Lane",
        "City": "Sarasota",
        "State": "FL",
        "Zip": "34233",
        "PhoneNumber": "(781) 706-7655",
        "Longitude": "-82.490828",
        "Latitude": "27.2780361",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10612,
        "StoreNumber": "John Heagy RRC",
        "StreetAddress": "10921 York Road",
        "City": "Cockeysville",
        "State": "MD",
        "Zip": "21030",
        "PhoneNumber": "(410) 329-1002",
        "Longitude": "-76.6450404",
        "Latitude": "39.4867026",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10613,
        "StoreNumber": "Just Fix It of SWFL",
        "StreetAddress": "17001 alico commerce ct",
        "City": "Fort Myers",
        "State": "FL",
        "Zip": "33967",
        "PhoneNumber": "(239) 440-4850",
        "Longitude": "-81.8227451",
        "Latitude": "26.4921888",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10614,
        "StoreNumber": "KIBA @ Brewer Carpet One",
        "StreetAddress": "801 W 15th St",
        "City": "Edmond",
        "State": "OK",
        "Zip": "73013",
        "PhoneNumber": "(405) 363-5422",
        "Longitude": "-97.494653",
        "Latitude": "35.638832",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10615,
        "StoreNumber": "Kissimmee Granite & Marble Inc",
        "StreetAddress": "2900 West Vine Street",
        "City": "Kissimmee",
        "State": "FL",
        "Zip": "34741",
        "PhoneNumber": "(407) 750-9080",
        "Longitude": "-81.4325706",
        "Latitude": "28.3040482",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10616,
        "StoreNumber": "Kitchen Design Cabinets",
        "StreetAddress": "10210 San Jose Boulevard",
        "City": "Jacksonville",
        "State": "FL",
        "Zip": "32257",
        "PhoneNumber": "(904) 229-7895",
        "Longitude": "-81.6258492",
        "Latitude": "30.1924863",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10617,
        "StoreNumber": "KITCHEN DESIGNS of the Em.",
        "StreetAddress": "1127 Cobb Parkway SE",
        "City": "Marietta",
        "State": "GA",
        "Zip": "30060",
        "PhoneNumber": "770-425-6992",
        "Longitude": "-84.504513",
        "Latitude": "33.924802",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10618,
        "StoreNumber": "Kitchen TuneUp #585",
        "StreetAddress": "1335 Wald Road",
        "City": "New Braunfels",
        "State": "TX",
        "Zip": "78132",
        "PhoneNumber": "(830) 387-4253",
        "Longitude": "-98.1597843",
        "Latitude": "29.6914199",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10619,
        "StoreNumber": "Kitchen Tune-Up #826",
        "StreetAddress": "1948 Franklin Road SW",
        "City": "Roanoke",
        "State": "VA",
        "Zip": "24014",
        "PhoneNumber": "(540) 274-3230",
        "Longitude": "-79.9504877",
        "Latitude": "37.2534301",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10620,
        "StoreNumber": "Kitchen Tune-Up Port Huron",
        "StreetAddress": "3200 Dove Road",
        "City": "Port Huron",
        "State": "MI",
        "Zip": "48060",
        "PhoneNumber": "(810) 488-9778",
        "Longitude": "-82.4622481",
        "Latitude": "42.9522846",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10621,
        "StoreNumber": "Kitchen Tune-Up Savannah",
        "StreetAddress": "1991 S US Highway 341",
        "City": "Jesup",
        "State": "GA",
        "Zip": "31546",
        "PhoneNumber": "(912) 424-4067",
        "Longitude": "-81.8553962",
        "Latitude": "31.5829751",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10622,
        "StoreNumber": "Kitchen Works LLC",
        "StreetAddress": "16572 Highway 13",
        "City": "Branson West",
        "State": "MO",
        "Zip": "65737",
        "PhoneNumber": "(417) 251-8535",
        "Longitude": "-93.3860198",
        "Latitude": "36.6813187",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10623,
        "StoreNumber": "Kitchens By Design Fimm",
        "StreetAddress": "4019 Oak Forest Cir.",
        "City": "Marietta",
        "State": "GA",
        "Zip": "30062",
        "PhoneNumber": "(404) 513-0579",
        "Longitude": "-84.4322215",
        "Latitude": "33.9951608",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10624,
        "StoreNumber": "Kreative Resources, Inc.",
        "StreetAddress": "1031 Miler Drive",
        "City": "Altamonte Springs",
        "State": "FL",
        "Zip": "32701",
        "PhoneNumber": "(407) 834-0114",
        "Longitude": "-81.3507578",
        "Latitude": "28.6801455",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10625,
        "StoreNumber": "Leatherman Supply",
        "StreetAddress": "2423 Peddlers Village Rd",
        "City": "Goshen",
        "State": "IN",
        "Zip": "46528",
        "PhoneNumber": "(574) 533-0597",
        "Longitude": "-85.8779832",
        "Latitude": "41.6105617",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10626,
        "StoreNumber": "Lehmann Homes",
        "StreetAddress": "4730 Cross Street",
        "City": "Philadelphia",
        "State": "PA",
        "Zip": "19128",
        "PhoneNumber": "(215) 260-8414",
        "Longitude": "-75.2270609",
        "Latitude": "40.0341085",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10627,
        "StoreNumber": "Lincoln Cabinet",
        "StreetAddress": "624 K Street",
        "City": "Lincoln",
        "State": "NE",
        "Zip": "68508",
        "PhoneNumber": "(402) 475-0650",
        "Longitude": "-96.7122765",
        "Latitude": "40.8095267",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10628,
        "StoreNumber": "Luv My Kitchens",
        "StreetAddress": "3455 NE 12th Ter",
        "City": "Oakland Park",
        "State": "FL",
        "Zip": "33334",
        "PhoneNumber": "(786) 276-9990",
        "Longitude": "-80.1305804",
        "Latitude": "26.1707279",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10629,
        "StoreNumber": "luxe design remodel",
        "StreetAddress": "5611 willowtwig lane",
        "City": "dayton",
        "State": "OH",
        "Zip": "45459",
        "PhoneNumber": "(513) 581-1815",
        "Longitude": "-84.2055111",
        "Latitude": "39.6706592",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10630,
        "StoreNumber": "Marrero Building LLC",
        "StreetAddress": "1509 Holmes Circle",
        "City": "Franklin",
        "State": "TN",
        "Zip": "37064",
        "PhoneNumber": "(615) 349-6332",
        "Longitude": "-86.8658469",
        "Latitude": "35.9075414",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10631,
        "StoreNumber": "Masterpiece Lighting & Home",
        "StreetAddress": "558 14th Street",
        "City": "Atlanta",
        "State": "GA",
        "Zip": "30318",
        "PhoneNumber": "(404) 897-9977",
        "Longitude": "-84.4055466",
        "Latitude": "33.7859017",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10632,
        "StoreNumber": "Mcgregors Landscape",
        "StreetAddress": "18700 Quamy",
        "City": "Riverview",
        "State": "MI",
        "Zip": "48193",
        "PhoneNumber": "(734) 288-0230",
        "Longitude": "-83.1792632",
        "Latitude": "42.1720271",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10633,
        "StoreNumber": "Mega home renovations",
        "StreetAddress": "605 cr-393",
        "City": "santa rosa beach",
        "State": "FL",
        "Zip": "32459",
        "PhoneNumber": "(850) 842-8678",
        "Longitude": "-86.2288322",
        "Latitude": "30.3960324",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10634,
        "StoreNumber": "Miami Aluminum Pergola Inc",
        "StreetAddress": "6175 NW 167th Street",
        "City": "Miami",
        "State": "FL",
        "Zip": "33015",
        "PhoneNumber": "(786) 605-1675",
        "Longitude": "-80.3015106",
        "Latitude": "25.9267461",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10635,
        "StoreNumber": "Michigan Kitchen Distributors",
        "StreetAddress": "106 E Oliver Drive",
        "City": "Marshall",
        "State": "MI",
        "Zip": "49086",
        "PhoneNumber": "(269) 781-5131",
        "Longitude": "-84.9547651",
        "Latitude": "42.2458089",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10636,
        "StoreNumber": "Mulberry Millworks, LLC",
        "StreetAddress": "2265 Clements Ferry Rd. Suite 307",
        "City": "Charleston",
        "State": "SC",
        "Zip": "29492",
        "PhoneNumber": "(843) 936-6128",
        "Longitude": "-79.9072011",
        "Latitude": "32.9052173",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10637,
        "StoreNumber": "Next Day Floors",
        "StreetAddress": "7100 Rutherford Road",
        "City": "Baltimore",
        "State": "MD",
        "Zip": "21244",
        "PhoneNumber": "(410) 944-0010",
        "Longitude": "-76.7475176",
        "Latitude": "39.3284004",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10638,
        "StoreNumber": "Nisbet, Inc",
        "StreetAddress": "11575 Reading Road",
        "City": "Cincinnati",
        "State": "OH",
        "Zip": "45241",
        "PhoneNumber": "(513) 563-1111",
        "Longitude": "-84.4118542",
        "Latitude": "39.2824645",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10639,
        "StoreNumber": "North Bay Cabinetry Corp.",
        "StreetAddress": "1763 Bay Grove Road",
        "City": "Freeport",
        "State": "FL",
        "Zip": "32439",
        "PhoneNumber": "(850) 419-4973",
        "Longitude": "-86.1589557",
        "Latitude": "30.4501682",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10640,
        "StoreNumber": "Oasis Outdoors LLC - Oasis Ho.",
        "StreetAddress": "3119 Civic Circle Blvd",
        "City": "Marion",
        "State": "IL",
        "Zip": "62959",
        "PhoneNumber": "(618) 992-2040",
        "Longitude": "-88.9816982",
        "Latitude": "37.7494748",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10641,
        "StoreNumber": "ONeil Industries Inc",
        "StreetAddress": "8821 Business Park Dr",
        "City": "Fort Myers",
        "State": "FL",
        "Zip": "33913",
        "PhoneNumber": "(239) 360-1000",
        "Longitude": "-81.8116715",
        "Latitude": "26.5071743",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10642,
        "StoreNumber": "Outdoor Kitchens of Iowa",
        "StreetAddress": "1152 SE Gateway Drive",
        "City": "Grimes",
        "State": "IA",
        "Zip": "50111",
        "PhoneNumber": "(515) 313-6174",
        "Longitude": "-93.7784882",
        "Latitude": "41.6791616",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10643,
        "StoreNumber": "Palm Beach Premier Remodeling",
        "StreetAddress": "515 South H Street",
        "City": "Lake Worth",
        "State": "FL",
        "Zip": "33461",
        "PhoneNumber": "(561) 444-2923",
        "Longitude": "-80.0588403",
        "Latitude": "26.6092613",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10644,
        "StoreNumber": "Pfeffer Outdoor Living",
        "StreetAddress": "320 Highway 18 West",
        "City": "Algona",
        "State": "IA",
        "Zip": "50511",
        "PhoneNumber": "(515) 295-6299",
        "Longitude": "-94.241411",
        "Latitude": "43.083331",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10645,
        "StoreNumber": "Premier Kitchen Design Services",
        "StreetAddress": "59 3rd Street Bonita Springs",
        "City": "Bonita Springs",
        "State": "FL",
        "Zip": "34134",
        "PhoneNumber": "(239) 770-1092",
        "Longitude": "-81.8221373",
        "Latitude": "26.3280821",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10646,
        "StoreNumber": "ProSource of Birmingham",
        "StreetAddress": "197 Chandalar Place Drive",
        "City": "Pelham",
        "State": "AL",
        "Zip": "36526",
        "PhoneNumber": "(205) 624-4764",
        "Longitude": "-86.8044934",
        "Latitude": "33.3147226",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10647,
        "StoreNumber": "ProSource of Erie",
        "StreetAddress": "1415 Peninsula Drive",
        "City": "Erie",
        "State": "PA",
        "Zip": "16505",
        "PhoneNumber": "(814) 455-7900",
        "Longitude": "-80.1434695",
        "Latitude": "42.0977378",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10648,
        "StoreNumber": "ProSource of Knoxville",
        "StreetAddress": "2820 Middlebrook Pike Suite 104",
        "City": "Knoxville",
        "State": "TN",
        "Zip": "37921",
        "PhoneNumber": "(865) 381-7171",
        "Longitude": "-83.9591494",
        "Latitude": "35.9632916",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10649,
        "StoreNumber": "PROSOURCE OF NASSAU",
        "StreetAddress": "303 Sunnyside Blvd",
        "City": "Plainview",
        "State": "NY",
        "Zip": "11803",
        "PhoneNumber": "(516) 576-0000",
        "Longitude": "-73.4665431",
        "Latitude": "40.7976304",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10650,
        "StoreNumber": "ProSource of NW Arkansas",
        "StreetAddress": "2301 N 17th St",
        "City": "Rogers",
        "State": "AR",
        "Zip": "72756",
        "PhoneNumber": "(479) 372-6490",
        "Longitude": "-94.1391388",
        "Latitude": "36.3546369",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10651,
        "StoreNumber": "ProSource of Pensacola",
        "StreetAddress": "33 Brent Lane Suite 107",
        "City": "Pensacola",
        "State": "FL",
        "Zip": "32503",
        "PhoneNumber": "(850) 434-8744",
        "Longitude": "-87.2389749",
        "Latitude": "30.4662492",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10652,
        "StoreNumber": "ProSource of Port Richey",
        "StreetAddress": "10929 State Road 52",
        "City": "Hudson",
        "State": "FL",
        "Zip": "34669",
        "PhoneNumber": "(727) 379-9700",
        "Longitude": "-82.6342917",
        "Latitude": "28.3323002",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10653,
        "StoreNumber": "Prosource Of Raleigh",
        "StreetAddress": "2409 Alwin Court",
        "City": "Raleigh",
        "State": "NC",
        "Zip": "27604",
        "PhoneNumber": "(724) 586-9350",
        "Longitude": "-78.6171994",
        "Latitude": "35.8124904",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10654,
        "StoreNumber": "ProSource of Roanoke",
        "StreetAddress": "1250B Trapper Circle NW",
        "City": "Roanoke",
        "State": "VA",
        "Zip": "24012",
        "PhoneNumber": "(540) 366-7737",
        "Longitude": "-79.9658356",
        "Latitude": "37.3311878",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10655,
        "StoreNumber": "ProSource Of Sarasota",
        "StreetAddress": "8159 25th court east",
        "City": "Sarasota",
        "State": "FL",
        "Zip": "34243",
        "PhoneNumber": "(941) 358-1600",
        "Longitude": "-82.5318173",
        "Latitude": "27.3938083",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10656,
        "StoreNumber": "PS WHOLESALE FLOORS LLC",
        "StreetAddress": "1683 O'Neal Lane",
        "City": "Baton Rouge",
        "State": "LA",
        "Zip": "70816",
        "PhoneNumber": "225-588-9832",
        "Longitude": "-91.005515",
        "Latitude": "30.4454136",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10657,
        "StoreNumber": "R & D Stones Corp",
        "StreetAddress": "5520 Georgia Ave",
        "City": "West Palm Beach",
        "State": "FL",
        "Zip": "33405",
        "PhoneNumber": "(561) 389-5755",
        "Longitude": "-80.0585758",
        "Latitude": "26.6639494",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10658,
        "StoreNumber": "RBC Enterprises Limited Inc.",
        "StreetAddress": "P.O box 2283",
        "City": "Joplin",
        "State": "MO",
        "Zip": "64803",
        "PhoneNumber": "(417) 850-1781",
        "Longitude": "-94.52",
        "Latitude": "37.11",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10659,
        "StoreNumber": "ROSWELL GENERAL",
        "StreetAddress": "35 Woodstock Road",
        "City": "Roswell",
        "State": "GA",
        "Zip": "30075",
        "PhoneNumber": "(770) 585-5811",
        "Longitude": "-84.362341",
        "Latitude": "34.0320698",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10660,
        "StoreNumber": "Sarisand Tile",
        "StreetAddress": "1226 Hamis Street",
        "City": "Charlottesville",
        "State": "VA",
        "Zip": "22903",
        "PhoneNumber": "(434) 964-4680",
        "Longitude": "-78.4793431",
        "Latitude": "38.040202",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10661,
        "StoreNumber": "Scott Payne Custom Pools",
        "StreetAddress": "2367 North Penn Rd-Suite 200",
        "City": "Hatfield",
        "State": "PA",
        "Zip": "19440",
        "PhoneNumber": "(215) 716-7177",
        "Longitude": "-75.2878532",
        "Latitude": "40.2925883",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10662,
        "StoreNumber": "Service One Construction Inc",
        "StreetAddress": "281 Skip Lane Unit J",
        "City": "Bay Shore",
        "State": "NY",
        "Zip": "11706",
        "PhoneNumber": "(631) 284-7728",
        "Longitude": "-73.2848903",
        "Latitude": "40.7638691",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10663,
        "StoreNumber": "Sierra Select Distributors, Inc.",
        "StreetAddress": "4320 Roseville Rd",
        "City": "North Highlands",
        "State": "CA",
        "Zip": "95660",
        "PhoneNumber": "(916) 483-9295",
        "Longitude": "-121.3961551",
        "Latitude": "38.6456886",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10664,
        "StoreNumber": "SmartPro Supply",
        "StreetAddress": "15551 Northland Drive",
        "City": "Cedar Springs",
        "State": "MI",
        "Zip": "49319",
        "PhoneNumber": "(616) 327-7660",
        "Longitude": "-85.5433507",
        "Latitude": "43.2508861",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10665,
        "StoreNumber": "SO Design Collective LLC",
        "StreetAddress": "19 Depot Street",
        "City": "Uxbridge",
        "State": "MA",
        "Zip": "01569",
        "PhoneNumber": "(508) 768-5659",
        "Longitude": "-71.6268685",
        "Latitude": "42.0759461",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10666,
        "StoreNumber": "South Side Lumber and Design",
        "StreetAddress": "1300 S Park Ave",
        "City": "HERRIN",
        "State": "IL",
        "Zip": "62948",
        "PhoneNumber": "(618) 942-3111",
        "Longitude": "-89.0276409",
        "Latitude": "37.7912683",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10667,
        "StoreNumber": "South Walton Cabinets",
        "StreetAddress": "457 Serenoa Road",
        "City": "Santa Rosa Beach",
        "State": "FL",
        "Zip": "32459",
        "PhoneNumber": "(850) 267-3909",
        "Longitude": "-86.0691292",
        "Latitude": "30.3461915",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10668,
        "StoreNumber": "Standale Home Studio",
        "StreetAddress": "4046 Lake Michigan Drive",
        "City": "Grand Rapids",
        "State": "MI",
        "Zip": "49534",
        "PhoneNumber": "(616) 735-5801",
        "Longitude": "-85.7677113",
        "Latitude": "42.9717599",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10669,
        "StoreNumber": "Stone Innovations, Inc.",
        "StreetAddress": "3611 Post Road",
        "City": "Plover",
        "State": "WI",
        "Zip": "54467",
        "PhoneNumber": "(715) 345-1601",
        "Longitude": "-89.5398487",
        "Latitude": "44.4448008",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10670,
        "StoreNumber": "Style Granite and marble inc",
        "StreetAddress": "2271 HYLAN BLVD",
        "City": "Staten Island",
        "State": "NY",
        "Zip": "10306",
        "PhoneNumber": "718-272-0919",
        "Longitude": "-74.1052305",
        "Latitude": "40.5754734",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10671,
        "StoreNumber": "Suncoast Flooring and Design",
        "StreetAddress": "5668 Gulf Breeze Parkway",
        "City": "Gulf Breeze",
        "State": "FL",
        "Zip": "32563",
        "PhoneNumber": "(850) 932-7474",
        "Longitude": "-86.985908",
        "Latitude": "30.4025266",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10672,
        "StoreNumber": "Tailored Design Studio",
        "StreetAddress": "300 E Oakland",
        "City": "Lansing",
        "State": "MI",
        "Zip": "48906",
        "PhoneNumber": "(517) 667-0098",
        "Longitude": "-84.5490519",
        "Latitude": "42.7428966",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10673,
        "StoreNumber": "TDM Custom Cabinetry",
        "StreetAddress": "2775 W US Rt 22 & 3",
        "City": "Maineville",
        "State": "OH",
        "Zip": "45039",
        "PhoneNumber": "(513) 677-3800",
        "Longitude": "-999",
        "Latitude": "-999",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10674,
        "StoreNumber": "The Cabinet Gallery, Inc.",
        "StreetAddress": "633 NW Baker Road",
        "City": "Stuart",
        "State": "FL",
        "Zip": "34994",
        "PhoneNumber": "(772) 692-3667",
        "Longitude": "-80.2615047",
        "Latitude": "27.2225856",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10675,
        "StoreNumber": "The Flooring Zone",
        "StreetAddress": "1956 SW Main Blvd.",
        "City": "Lake City",
        "State": "FL",
        "Zip": "32025",
        "PhoneNumber": "(386) 965-3574",
        "Longitude": "-82.6428158",
        "Latitude": "30.1627162",
        "URI": "",
        "IsCLStore": null,
        "Classification": null
    },
    {
        "ID": 10676,
        "StoreNumber": "The Hague Construction inc",
        "StreetAddress": "4775 mercantile ave Unit",
        "City": "Naples",
        "State": "FL",
        "Zip": "34104",
        "PhoneNumber": "(239) 601-6014",
        "Longitude": "-81.7512691",
        "Latitude": "26.166692",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10677,
        "StoreNumber": "The Outdoor Kitchen Outlet",
        "StreetAddress": "1306 Cape Coral Pkwy E",
        "City": "Cape Coral",
        "State": "FL",
        "Zip": "33904",
        "PhoneNumber": "(239) 405-0888",
        "Longitude": "-81.9483039",
        "Latitude": "26.5622009",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10678,
        "StoreNumber": "The Wheelhouse Design Com..",
        "StreetAddress": "2217 Pumphrey Ave",
        "City": "Auburn",
        "State": "AL",
        "Zip": "36832",
        "PhoneNumber": "(706) 627-9931",
        "Longitude": "-85.5203608",
        "Latitude": "32.6016279",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10679,
        "StoreNumber": "This N That",
        "StreetAddress": "8804 SW 129 Street",
        "City": "Miami",
        "State": "FL",
        "Zip": "33176",
        "PhoneNumber": "(786) 251-1528",
        "Longitude": "-80.3366966",
        "Latitude": "25.6503737",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10680,
        "StoreNumber": "Tilmanns Custom Cabinets",
        "StreetAddress": "2497 W River Road",
        "City": "Mount Pleasant",
        "State": "MI",
        "Zip": "48858",
        "PhoneNumber": "989) 330-9422",
        "Longitude": "-84.897816",
        "Latitude": "43.6260742",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10681,
        "StoreNumber": "Tiple 7 Holdings LLC",
        "StreetAddress": "100 Industrial Circle",
        "City": "Sebastian",
        "State": "FL",
        "Zip": "32958",
        "PhoneNumber": "(772) 228-9018",
        "Longitude": "-80.4857499",
        "Latitude": "27.8286945",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10682,
        "StoreNumber": "Tru Closet Pros",
        "StreetAddress": "308 165th CT NE",
        "City": "Bradenton",
        "State": "FL",
        "Zip": "34212",
        "PhoneNumber": "(941) 229-1433",
        "Longitude": "-82.3727255",
        "Latitude": "27.5032009",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10683,
        "StoreNumber": "Tukasa Creations",
        "StreetAddress": "6777 Weber Road",
        "City": "Corpus Christi",
        "State": "TX",
        "Zip": "78413",
        "PhoneNumber": "(361) 851-9440",
        "Longitude": "-97.416052",
        "Latitude": "27.6946565",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10684,
        "StoreNumber": "Ultimate Cabinets & Interiors by..",
        "StreetAddress": "17600 Rockefeller Cir Suite 4",
        "City": "Fort Myers",
        "State": "FL",
        "Zip": "33967",
        "PhoneNumber": "(239) 270-5145",
        "Longitude": "-81.8324897",
        "Latitude": "26.4786691",
        "URI": "",
        "IsCLStore": null,
        "Classification": null
    },
    {
        "ID": 10685,
        "StoreNumber": "UR Cabinets CFL",
        "StreetAddress": "102 South Evers Street",
        "City": "Plant City",
        "State": "FL",
        "Zip": "33563",
        "PhoneNumber": "(813) 785-1033",
        "Longitude": "-82.123697",
        "Latitude": "28.014847",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10686,
        "StoreNumber": "Viagers' Buying Club, LLC",
        "StreetAddress": "2113 Everglades Lane",
        "City": "The Villages",
        "State": "FL",
        "Zip": "32163",
        "PhoneNumber": "(352) 552-8218",
        "Longitude": "-82.0066846",
        "Latitude": "28.8016993",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10687,
        "StoreNumber": "Wayne Lumber & Supply",
        "StreetAddress": "542 West High Street",
        "City": "Waynesburg",
        "State": "PA",
        "Zip": "15370",
        "PhoneNumber": "(724) 627-3171",
        "Longitude": "-80.180686",
        "Latitude": "39.899754",
        "URI": "",
        "IsCLStore": null,
        "Classification": null
    },
    {
        "ID": 10688,
        "StoreNumber": "Wisenbaker Builder Services",
        "StreetAddress": "1703 Westfield Loop",
        "City": "Houston",
        "State": "TX",
        "Zip": "77073",
        "PhoneNumber": "832-475-5393",
        "Longitude": "-95.399956",
        "Latitude": "30.0199806",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10689,
        "StoreNumber": "Woodford Plywood, Inc.",
        "StreetAddress": "P.O. Box 50007",
        "City": "Albany",
        "State": "GA",
        "Zip": "31703",
        "PhoneNumber": "(800) 342-6400",
        "Longitude": "-84.155741",
        "Latitude": "31.5785074",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    },
    {
        "ID": 10690,
        "StoreNumber": "Woodland Direct Inc",
        "StreetAddress": "2025 Taylor Rd",
        "City": "Auburn Hills",
        "State": "MI",
        "Zip": "48326",
        "PhoneNumber": "(248) 838-1301",
        "Longitude": "-83.2534859",
        "Latitude": "42.6907542",
        "URI": "",
        "IsCLStore": 0,
        "Classification": null
    }
]`); */

((window) => {
    function handleSelectSingleNode(domWraper, nodeStr = "") {
        const nodeList = nodeStr.split('/');
        if (nodeList.length == 1) {
            return domWraper.querySelector(nodeList[0])
        } else {
            domWraper = domWraper.querySelector(nodeList[0]);
            if (!domWraper) {
                throw new Error(`This node was not found : ${nodeList[0]}`)
            }
            nodeList.shift();
            return handleSelectSingleNode(domWraper, nodeList.join('/'))
        }
    }
    class GoogleMapPoint {
        constructor({ lat, lng, key = null, isSuccess = true, errorMessage = "", formattedAddress = "" }) {
            this.lat = lat;
            this.lng = lng;
            this.key = key;
            this.isSuccess = isSuccess;
            this.errorMessage = errorMessage;
            this.formattedAddress = formattedAddress;
        }
    }
    function getStatusCodeDesc(statusCode) {
        statusCode = statusCode.trim().toUpperCase()
        let result = "";

        switch (statusCode) {
            case "OK":
                break;
            case "ZERO_RESULTS":
                result = "indicates that the geocode was successful but returned no results. This may occur if the geocoder was passed a non-existent address.";
                break;
            case "OVER_QUERY_LIMIT":
                result = "indicates that you are over your quota.";
                break;
            case "REQUEST_DENIED":
                result = "indicates that your request was denied.";
                break;
            case "INVALID_REQUEST":
                result = "generally indicates that the query (address, components or latlng) is missing.";
                break;
            case "UNKNOWN_ERROR":
                result = " indicates that the request could not be processed due to a server error. The request may succeed if you try again.";
                break;
        }
        return result;
    }
    class googleMap {
        constructor(dbJson) {
            this.storeFinder = dbJson;
            // this.storeFinder = null;
            this.EARTH_RADIUS = 6378.137; //Earth radius KM
            this.DEFAULT_LONGITUDE_LATITUDE = "-999d";
            this.googleApiKey = "AIzaSyDtSpMYGKCxPIJELMfVPYyh8KnrLuo8rbs";
            this.googleUrl = `https://maps.googleapis.com/maps/api/geocode/xml`;
            this.initStoreFinder()
        }
        async initStoreFinder() {
            // this.storeFinder = dbJson;
        }
        async getModifiStoresFromLatLng(lat, lng) {
            var result = await this.getAddressFromLatLng(lat, lng);
            return await this.LoadModifiStores(result);
        }
        async getAddressFromLatLng(lat, lng) {
            const requestUrl = `${this.googleUrl}?latlng=${lat.toString()},${lng.toString()}&key=${this.googleApiKey}`;
            let success = false;
            let errorMsg = "";
            let formatAddress = "";
            const responseStr = await fetch(requestUrl).then(v => v.text());
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(responseStr, "text/xml");
            const statusCode = handleSelectSingleNode(xmlDoc, 'status').innerHTML.trim();
            errorMsg = getStatusCodeDesc(statusCode)
            if (statusCode.toUpperCase() == 'OK') {
                formatAddress = handleSelectSingleNode(xmlDoc, "result/formatted_address").innerHTML.trim();
                success = true;
            } else {
                errorMsg = responseStr
            }
            return new GoogleMapPoint({ lat, lng, isSuccess: success, errorMessage: errorMsg, formattedAddress: formatAddress });
        }
        async getModifiStoresFromAddress(fullAddress) {
            const result = await this.getGeocodingByAddress(fullAddress);
            return await this.LoadModifiStores(result)
        }
        getFormatFullAddress(address = "", city = "", state = "", zipCode = "") {
            let fullAddress = "";
            fullAddress += address.trim().replace(" ", "+");
            if (city.trim().Length > 0) {
                if (fullAddress.trim().Length > 0) fullAddress += ",+";
                fullAddress += city.trim().replace(" ", "+");
            }
            if (state.trim().Length > 0) {
                if ((city.trim().Length == 0 && fullAddress.Length > 0) || city.trim().Length > 0) fullAddress += ",+";
                fullAddress += state.trim().replace(" ", "+");
                if (zipCode.trim().Length > 0) {
                    fullAddress += string.Concat("+", zipCode.trim());
                }
            }
            else if (zipCode.trim().Length > 0) {
                if ((city.trim().Length == 0 && fullAddress.Length > 0) || city.trim().Length > 0) fullAddress += ",+";
                fullAddress += zipCode.trim();
            }
            return fullAddress;
        }
        async _getFormatFullAddress(fullAddress) {
            var result = await this.getGeocodingByAddress(fullAddress);
            return this.LoadModifiStores(result);
        }
        async _getGeocodingByAddress() {
            return await this.getGeocodingByAddress(this.getFormatFullAddress(address, city, state, zipCode));
        }
        async getGeocodingByAddress(fullAddress) {
            const requestUrl = `${this.googleUrl}?address=${fullAddress}&key=${this.googleApiKey}`;
            let lat = "-999.0d";
            let lng = "-999.0d";
            let success = false;
            let errorMsg = "";
            let formatAddress = "";

            const responseStr = await fetch(requestUrl).then(v => v.text());
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(responseStr, "text/xml");
            const statusCode = handleSelectSingleNode(xmlDoc, 'status').innerHTML.trim();
            errorMsg = getStatusCodeDesc(statusCode);
            if (statusCode.toUpperCase() == "OK") {
                formatAddress = handleSelectSingleNode(xmlDoc, "result/formatted_address").innerHTML.trim()
                const locationNode = handleSelectSingleNode(xmlDoc, "result/geometry/location");
                lat = handleSelectSingleNode(locationNode, "lat").innerHTML.trim() * 1;
                lng = handleSelectSingleNode(locationNode, "lng").innerHTML.trim() * 1;
                success = true;
            } else {
                const errorMes = responseStr
            }
            return new GoogleMapPoint({ lat, lng, isSuccess: success, errorMessage: errorMsg, formattedAddress: formatAddress });
        }
        async LoadModifiStores(currentData) {
            currentData.key = this.googleApiKey;
            if (!currentData.isSuccess) {
                return currentData
            }
            const ModifiStoresList = [];
            this.storeFinder.forEach((item, index) => {
                item.StoreNo = item.StoreNumber.replace(/\D/g, '');
                item.Longitude = item.Longitude * 1;
                item.Latitude = item.Latitude * 1;
                if (item.Longitude == this.DEFAULT_LONGITUDE_LATITUDE && item.Latitude == this.DEFAULT_LONGITUDE_LATITUDE) {
                    var temp = this._getGeocodingByAddress(item.StreetAddress, item.City, item.State, item.Zip);
                    if (temp.isSuccess) {
                        item.Longitude = temp.lng;
                        item.Latitude = temp.lat;
                        //update db
                        // DB.ExecuteSQL("UPDATE [storefinder] SET Longitude=" + item.longitude + ",Latitude=" + item.latitude + " WHERE ID=" + DB.RSFieldInt(rs, "ID"));
                    }
                }
                if (item.Longitude != this.DEFAULT_LONGITUDE_LATITUDE && item.Latitude != this.DEFAULT_LONGITUDE_LATITUDE) {

                    item.Distance = this.getDistanceFromGoogleMapPoint(currentData, new GoogleMapPoint({ lat: item.Latitude, lng: item.Longitude }));
                }
                else {
                    item.Distance = -1;
                }
                ModifiStoresList.push(item)
            })
            ModifiStoresList.sort((a, b) => {
                if (a.isCLStore && !b.isCLStore) return -1;
                if (!a.isCLStore && b.isCLStore) return 1;
                return a.distance - b.distance;
            });
            if (ModifiStoresList.length > 0) {
                const firstCLStore = ModifiStoresList.find(item => item.isCLStore);
                if (firstCLStore) {
                    const index = ModifiStoresList.indexOf(firstCLStore);
                    if (index > 0) {
                        ModifiStoresList.splice(index, 1);
                        ModifiStoresList.unshift(firstCLStore);
                    }
                }
            }
            currentData.StoreList = ModifiStoresList;
            return currentData
        }
        getDistanceFromGoogleMapPoint(p1, p2) {
            let radLat1 = p1.lat * (Math.PI / 180);
            let radLat2 = p2.lat * (Math.PI / 180);

            let a = radLat1 - radLat2;
            let b = p1.lng * (Math.PI / 180) - p2.lng * (Math.PI / 180);
            let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
            s = s * this.EARTH_RADIUS;
            s = Math.round(s * 10000) / 10000;   //km
            //Kilometers to Miles 
            s = s * 0.621371192;

            return s;  //Miles
        }
    }
    window.googleMap = googleMap
})(window)